import { render, staticRenderFns } from "./ChatbotBuilderList.vue?vue&type=template&id=30927c46&scoped=true"
import script from "./ChatbotBuilderList.vue?vue&type=script&lang=js"
export * from "./ChatbotBuilderList.vue?vue&type=script&lang=js"
import style0 from "./ChatbotBuilderList.vue?vue&type=style&index=0&id=30927c46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30927c46",
  null
  
)

export default component.exports